<div class="group relative">
  <label class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
    {{ label() }}
  </label>
  <select
    [ngModel]="value()"
    (ngModelChange)="value.set($event)"
    class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black">
    <option [ngValue]="undefined" class="placeholder:text-gray-300">
      {{ defaultOption() }}
    </option>

    @for (opt of options(); track opt.id) {
      <option [ngValue]="opt.id">
        {{ isArabic() ? opt.titleAr || opt.titleEn : opt.titleEn }}
      </option>
    }
  </select>
</div>
